import Axios from 'axios'
import type { AxiosInstance, AxiosRequestConfig } from 'axios'

import { getAccessToken } from '@functions/accessToken'

const urls = {
  production: 'https://api.aim.realbase.io/v1',
  staging: 'https://api.aim.staging.realbase.io/v1',
  development: 'https://api.aim.development.realbase.io/v1',
  test: 'https://localhost:5001/v1',
}

export const baseURL = urls[process.env.REACT_APP_APPLICATION_ENV]

const axiosConfig: AxiosRequestConfig = {
  baseURL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
}

const axios: AxiosInstance = Axios.create(axiosConfig)

axios.interceptors.request.use(
  async (config) => {
    const accessToken = getAccessToken()

    const updatedConfig = {
      ...config,
      headers: {
        ...config.headers,
        Authorization: `Bearer ${accessToken}`,
      },
    }

    return updatedConfig
  },
  (error) => {
    // Do something with request error
    Promise.reject(error)
  },
)

axios.interceptors.response.use(
  response => response,
  responseError => Promise.reject(responseError.response.data),
)

const baseConfig: AxiosRequestConfig = {
  method: 'get',
  paramsSerializer: {
    indexes: null,
  },
}

const api = (
  url: string,
  options: any = {},
  config: AxiosRequestConfig = {},
) => {
  const mergedConfig: AxiosRequestConfig = { ...baseConfig, ...config }

  // Remove entityKey from requestOptions
  const { entityKey, ...requestOptions } = options

  return axios({
    ...mergedConfig,
    params: options,
    url,
  })
}

export default api
